import {
  PartialAvailability,
  PartialCampus,
  PartialPatient,
  PartialService
} from "./AppointmentItem";

export class CalendarEventModel {
  id = "";
  key?: string;
  name = "";
  start: Date = new Date();
  end: Date = new Date();
  color = "";
  timed = true;
  campus: PartialCampus = new PartialCampus();
  patient: PartialPatient = new PartialPatient();
  service: PartialService = new PartialService();
  availability: PartialAvailability = new PartialAvailability();
  state = "";
}
